module.exports = __webpack_public_path__ + "img/花草_01.e5a0fd2d.png";